import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactLoading from "react-loading";
import { GLOBAL_STYLES } from "../appConstants";
import InteractiveGraph from "../BhuMeetTeams/BhuMeetFinance/Orders/SubComponents/OrdersGraph";
import useWindowSize from "../hooks/useWindowSize";

const DashboardMainCard = ({ height, animatedElement, loading, view, title, mainData, subData, isDisabled, graphData }) => {
    const navigate = useNavigate();
    const [showAnimation, setShowAnimation] = useState(false)
    const {currentWidth}=useWindowSize();

    return (
        <div
            className="dashboard-main-card"
            style={{ height: height || '290px' }}
            onClick={(e) => {
                if (!isDisabled) {
                    e.stopPropagation()
                    if (view) {
                        navigate(view)
                    }
                }
            }}
            onMouseOver={() => setShowAnimation(true)}
        >
            {loading ? <div style={{ position: "relative", height: "100%", width: "100%" }}>
                <ReactLoading
                    className="loading"
                    type={"spin"}
                    color={GLOBAL_STYLES.BG_ACTIVE}
                    height={"13%"}
                    width={"10%"}
                />
            </div> : <>
                <div className="dashboard-card-padding">
                    <div className="dashboard-cards-heading" >{title}</div>
                    <div style={{ height: "30%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-start", marginTop: "9px" }}>
                        <div className="dashboard-cards-main-data">{mainData}</div>
                        <div className="dashboard-cards-sub-data">{subData}</div>
                    </div>
                </div>
                {/* <div
                    className="dashboard-main-card-animation"
                    style={{ top: showAnimation ? "-2px" : "14px", opacity: showAnimation ? 1 : 0 }}
                >
                    {animatedElement}
                </div> */}
                {graphData.length &&
                    <InteractiveGraph
                        data={graphData}
                        lineType={0}
                        isShowTooltip={false}
                        leftPriceScaleVisible={false}
                        isTimeScaleVisible={false}
                        isTimeVisible={false}
                        isShowCrosshairMarker={false}
                        loading={loading}
                        style={{ height: currentWidth<1500?"114px":currentWidth<1800?"130px":"155px", minHeight:currentWidth<1500?"114px":currentWidth<1800?"130px":"155px", margin: 0, boxShadow: "none" }}
                        crosshairMode={2}
                        priceLineVisible={false}
                    />
                }
            </>
            }
        </div>
    );
};

export default DashboardMainCard;
